<script setup lang="ts">
import { Document } from '@contentful/rich-text-types'
import { BG, getForeground } from './richTextHelpers'
import { TableData } from '~/components/cms/Table/Table.vue'

export type RichTextPanelSupportingData = {
  home: {
    backgroundColourForRichTextPanel?: {
      value: BG
      children: {
        fontColour: {
          value: string
        }
      }
    }
    backgroundColourForProductPromotion?: {
      value: BG
      children: {
        fontColour: {
          value: string
        }
      }
    }
    removeBottomMargin?: {
      value: boolean
    }
    variant?: {
      value: 'center' | 'left'
    }
    sizeGuideCategory?: {
      value: 'rings' | 'banglesAndBracelets' | 'necklacesAndChains'
    }
  }
}

export type RichTextPanelProps = {
  content?: Document
  skipContainer?: boolean
  table?: { fields: { table: TableData } }[]
  supportingData?: RichTextPanelSupportingData
}

const props = withDefaults(defineProps<RichTextPanelProps>(), {
  skipContainer: false,
})
const supportingData = props.supportingData?.home
const richTextConfig =
  supportingData?.backgroundColourForRichTextPanel || supportingData?.backgroundColourForProductPromotion
const background = richTextConfig?.value
const foreground = richTextConfig?.children?.fontColour?.value
const isNoMarginBottom = supportingData?.removeBottomMargin?.value
const isCenter = supportingData?.variant?.value === 'center'
const isLeft = supportingData?.variant?.value === 'left'
const color = foreground || getForeground(background)
// Table used in Ring size Modal
const tableData = props.table?.[0]?.fields?.table
</script>
<template>
  <div
    class="rich-text-panel"
    data-testid="rich-text-panel"
    :class="{
      'rich-text-panel--no-margin-bottom': isNoMarginBottom || skipContainer, // skipContainer = not a stand alone component
      'rich-text-panel--center': isCenter,
      'rich-text-panel--left': isLeft,
    }"
    :style="{ background, color }"
  >
    <div :class="{ container: !skipContainer }">
      <Table v-if="tableData" :table="tableData" />
      <RichText :document="content" />
    </div>
  </div>
</template>

<style lang="postcss">
.rich-text-panel {
  margin-bottom: var(--component-space);
  text-align: left;
  overflow: hidden;

  &.rich-text-panel--no-margin-bottom {
    margin-bottom: 0;
  }
  &.rich-text-panel--center {
    text-align: center;
  }
  &.rich-text-panel--left {
    text-align: left;
  }
}
</style>
